import { useState, useEffect } from "react"
import axios from "axios"

const useFetch = () => {
  const [error, setError] = useState(null)
  const [response, setResponse] = useState([])
  const url = "https://www.bitmasta.io/php/admin_pass.php"
  useEffect(() => {
    const fetchData = async () => {
        const formData = new FormData()
        formData.append("Get_Rate",true)
        const res = await axios.post(url, formData)
        if(res)
        setResponse(res.data.Rates)
        else
        setError("An error occured.")
    }
    fetchData()
  }, [])

  return { response, error }
}

export default useFetch
